export default __webpack_public_path__ + "a50f5c744a4216d12c96d26fd43af620.png";